<template>
<div >
  <main class="py-4">
  <v-app>
    <v-content>
      <v-container
        class="fill-height"        
        fluid>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                class="listra" 
                dark
                flat
              >
              <v-spacer></v-spacer>
                <v-img
                alt="Quoon Name"
                class="shrink"
                contain
                min-width="100"
                src="https://firebasestorage.googleapis.com/v0/b/quoon-br.appspot.com/o/quoonbr%2Flogofull.png?alt=media&token=0f5a44bc-2237-4b7e-be04-156ea7e3a1f3"
                width="190"
                />              
                <v-spacer></v-spacer>
                <!-- <v-toolbar-title>Quoon Login</v-toolbar-title> -->
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="login"
                    label="Login"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <form action="#" @submit.prevent="submit">
                  <v-btn type="submit" color="primary" :loading="loading">Login</v-btn>
                </form>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
  </main>
</div>    
</template>

<script>
import firebase from "firebase"
import { db } from '../main'
import store from '../store'
import dbFunctions from '../dbFunctions'
  export default {
    props: {
      source: String,
    },
    data: () => ({
      login: '',
      password: '',
      loading: false
    }),
    created(){
      this.getDataInfo = dbFunctions.getDataInfo
      this.getCompanyInfo = dbFunctions.getCompanyInfo
    },
    methods:{
      checkAndRoute(authInfo){
        // console.log(authInfo.user,authInfo.user.email)
        db.collection('usuarios').where('email','==',authInfo.user.email).get()
        .then(async (snapshot) => {
          const userLogged = snapshot.docs.map(doc => doc.data())[0];
          userLogged.id = snapshot.docs.map(doc => doc.id);
          const empresaId = userLogged.empresa.id
          localStorage.sessionId = empresaId
          const empresa = await this.getCompanyInfo(empresaId)
          
          store.dispatch("fetchUser",userLogged)
          store.dispatch("fetchCompany",empresa)

          let dataStore = await this.getDataInfo(empresa.id)
          store.dispatch("fetchData",dataStore)
          this.$router.replace('Home')
        }).catch(function(error){
          console.error(error)
        })
      },
      submit() { 
        // console.log(this.login, this.password)
        this.loading = true
        firebase.auth().signInWithEmailAndPassword(this.login, this.password)
        .then(authInfo => {
          // console.log(authInfo)
          localStorage.loggedIn = true
          this.checkAndRoute(authInfo)
        }).catch(function(error){
          this.loading = false
          console.error(error.code)
        })   
      }       
    }
  }
</script>

<style scoped>
.listra {
    background: repeating-linear-gradient(
        #296B74,
        #296B74 20px,
        #1C4C5A 20px,
        #1C4C5A 45px
    );
}
</style>